<template>
  <div class="course-group-page">
    <div class="filter">
      <a-row :gutter="8">
        <a-col :span="4">
          <a-input
            class="select-item"
            v-model="searchParams.groupName"
            allow-clear
            placeholder="请输入小组名称"
          />
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.year"
            allow-clear
            placeholder="全部学年学期"
          >
            <a-select-option :value="item.id" v-for="(item,index) in yearListData" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.period"
            allow-clear
            placeholder="全部期次"
          >
            <a-select-option :value="item.id" v-for="(item,index) in baseData.period" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.classCycles"
            allow-clear
            placeholder="全部周期"
          >
            <a-select-option :value="item.id" v-for="(item,index) in baseData.classCycle" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.timeIntervals"
            allow-clear
            placeholder="全部时段"
          >
            <a-select-option :value="item.id" v-for="(item,index) in baseData.timeInterval" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-button type="primary" @click="handleSearchBtnClick" style="margin-right: 8px;">
            搜索
          </a-button>
          <a-button @click="handleResetBtnClick">
            重置
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="result">
      <a-col class="group-list" :span="5">
        <div class="list-wrap">
          <div v-if="groupListLoading" class="spin">
            <a-spin />
          </div>
          <div class="list">
            <div v-if="groupList && groupList.length > 0" :id="groupList.length">
              <GroupItem
                v-for="(item, index) in groupList"
                :key="index"
                :item-data="item"
                :selected-item="selectedGroupItem"
                @click="handleGroupItemClick"
              />
            </div>
            <a-empty class="empty" v-else />
          </div>
          <div class="pagination">
            <a-pagination
              v-if="groupPagination.totalPage>groupPagination.pageSize"
              v-model="groupPagination.current"
              :total="groupPagination.totalPage"
              :page-size="groupPagination.pageSize"
            />
          </div>
        </div>
      </a-col>
      <a-col class="course-list" :span="19">
        <header class="header">
          <span class="label">讲次列表</span><span class="label" v-show="lessonList.length > 0">（共{{ lessonList.length }}讲）</span>
          <a-button type="link" @click="refreshLesson">
            <a-icon type="sync" />
            刷新
          </a-button>
          <a-button
            v-show="!(selectedGroupItem && selectedGroupItem.sourceType === 2)"
            style="margin-left: 8px;"
            ghost
            type="primary"
            @click="getCourseDetail"
          >
            课程补充资料
          </a-button>
        </header>
        <a-table
          ref="table"
          class="table"
          row-key="id"
          :data-source="lessonList"
          :loading="lessonTableLoading"
          :columns="columnsList"
          :pagination="false"
          :scroll="scroll"
          :row-class-name="lessonRowClass"
        >
          <div slot="lock" slot-scope="text, record" :style="{'color': getColor(record)}">
            <svg-icon :style="{'color': getColor(record)}" v-show="record.lockStatus === 1" icon="lock" />
            <svg-icon :style="{'color': getColor(record)}" v-show="record.lockStatus === 2" icon="unlock" />
          </div>
          <div slot="lessonNum" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ `第${text}讲` }}
          </div>
          <div slot="lessonName" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ `${text}` }}
            <span class="tag" v-if="record.lessonTag !== 0">
              {{ record.lessonTag === 1 ? '期中' : '期末' }}
            </span>
          </div>
          <div class="min-width" slot="studyUserCount" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ record.lockStatus === 2 && text >= 0 ? `${text}人 ` : '--' }}
          </div>
          <div class="min-width-slot-title" slot="completeUserCountTitle">
            完成学习人数
            <a-tooltip placement="top">
              <template #title>
                <span>完成学AI课，课本例练，双色笔记，日积月累，融会贯通这五关的人数</span>
              </template>
              <span><a-icon type="question-circle" /></span>
            </a-tooltip>
          </div>
          <div class="min-width" slot="completeUserCount" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ record.lockStatus === 2 && text >= 0 ? `${text}人 ` : '--' }}
          </div>
          <div class="min-width" slot="correctionNum" slot-scope="text, record">
            <span v-if="isEmptyCpm(text, record)"> -- </span>
            <Popover
              v-else
              :lesson-info="record"
              :record-num="record.correctionDivisionNum"
              class-correct-type="1"
              :content="`${text}人（${record.correctionDivisionNum}份）`"
            />
          </div>
          <div class="min-width" slot="repulseNum" slot-scope="text, record">
            <span v-if="isEmptyCpm(text, record)"> -- </span>
            <Popover
              v-else
              :lesson-info="record"
              :record-num="record.repulseDivisionNum"
              class-correct-type="2"
              :content="`${text}人（${record.repulseDivisionNum}份）`"
            />
          </div>
          <div class="min-width" slot="excellentNum" slot-scope="text, record">
            <span v-if="isEmptyCpm(text, record)"> -- </span>
            <Popover
              v-else
              :lesson-info="record"
              :record-num="record.excellentDivisionNum"
              class-correct-type="3"
              :content="`${text}人（${record.excellentDivisionNum}份）`"
            />
          </div>
          <div class="min-width-slot-title" slot="correctionRateTitle">
            批改完成率
            <a-tooltip placement="top">
              <template #title>
                <span>批改完成率：已批改份/总提交份*100%</span>
              </template>
              <span><a-icon type="question-circle" /></span>
            </a-tooltip>
          </div>
          <div class="min-width" slot="correctionRate" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ text ? `${parseInt((text * 1000)/10)}%` : '--' }}
            <a-tooltip v-if="text" placement="right">
              <template slot="title">
                <p>已批改</p>
                <p>{{ record.correctUserCount }}人({{ record.correctCount }}份)</p>
              </template>
              <a-icon type="info-circle" class="tip-icon" />
            </a-tooltip>
          </div>
          <div class="min-width-slot-title" slot="submitRateTitle">
            学生提交率
            <a-tooltip placement="top">
              <template #title>
                <span>学生提交率：已提交人数/本讲学习人数 *100%</span>
              </template>
              <span><a-icon type="question-circle" /></span>
            </a-tooltip>
          </div>
          <div class="min-width" slot="submitRate" slot-scope="text, record" :style="{'color': getColor(record)}">
            {{ text ? `${parseInt((text * 1000)/10)}%` : '--' }}
          </div>
          <div slot="action" slot-scope="text, record" class="operate">
            <!-- 备课 -->
            <a-button v-gdd-hide type="link" @click="() => updatePrePareLesson(true, record)">
              备课
            </a-button>
            <!-- 解锁课前学 -->
            <template v-if="!(selectedGroupItem && selectedGroupItem.sourceType === 2)">
              <a-button v-gdd-hide :disabled="[-1, 1].includes(record.beforeClassState) " type="link" @click="() => unlockBeforeLess(record)">
                {{ [-1, 0].includes(record.beforeClassState) ? '解锁课前学' : '已解锁课前学' }}
              </a-button>
            </template>
            <!-- 授课/解锁讲次 -->
            <!-- coursewareVersion：-1 老数据； ""：没有备课 -->
            <a-button
              v-gdd-hide
              v-if="teacherControl && selectedGroupItem.sourceType !== 2"
              type="link"
              @click="() => giveLesson(record)"
              :disabled="record.coursewareVersion === '-1'"
            >
              {{ record.lockStatus === 1 ? '授课' : '打开授课' }}
            </a-button>
            <a-button v-else @click="() => handleUnlockLesson(record, selectedGroupItem)" type="link" :disabled="record.lockStatus === 2">
              {{ record.lockStatus === 1 ? '解锁讲次' : '已解锁讲次' }}
            </a-button>
            <!-- 批改 -->
            <a-button type="link" @click="correct(record, selectedGroupItem)" :disabled="(record.lockStatus !== 2) || Boolean(record.lessonTag)">
              批改
            </a-button>
          </div>
        </a-table>
      </a-col>
    </div>
    <PrepareLesson
      v-if="prePareLessonVisible"
      :visible="prePareLessonVisible"
      :group-info="selectedGroupItem"
      :lesson-info="selectedLessonItem"
      @updatePrePareVisible="updatePrePareLesson"
    />

    <a-modal
      centered
      :width="795"
      :visible="courseMaterialsVisible"
      :mask-closable="false"
      :footer="null"
      @cancel="courseMaterialsVisible = false"
    >
      <div slot="title" class="modal-course-title-wrap">
        <span class="title-name">课程补充资料</span>
        <div class="course-name-wrap">
          <a-divider
            class="divider"
            type="vertical"
            style="margin: 0 16px;"
          />
          <span class="course-name">{{ selectedGroupItem && selectedGroupItem.itvCourseName }} </span>
          <a-divider
            class="divider"
            type="vertical"
            style="margin: 0 16px;"
          />
        </div>
        <span class="course-id">课程ID：{{ selectedGroupItem && selectedGroupItem.classTypeId }}</span>
      </div>
      <CourseMaterials v-if="courseMaterialsVisible" :class-type-id="selectedGroupItem && selectedGroupItem.classTypeId" />
    </a-modal>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, computed, onActivated, watch } from 'vue-demi'
import { useGetLessonList, useGetGroupList } from './hooks'
import columns from './columns'
import mixins from '@/utils/mixins'
import GroupItem from './cmps/groupItem'
import Popover from './cmps/popover'
import service from '@/service/correction'
import PrepareLesson from './prepareLesson/index.vue'
import store from '@/store'
import correctLogger from '@/utils/logger/correct.js'
import CourseMaterials from '@/components/CourseMaterials'

export default defineComponent({
  name: 'CourseAndGroup',
  components: { GroupItem, Popover, PrepareLesson, CourseMaterials },
  mixins: [mixins],
  methods: {
    unlockBeforeLess(record) {
      const { xkhTeacherCourseId, classTypeId, lessonId, aiLessonId } = record
      correctLogger.openCourseBefore({
        lessonId,
        aiLessonId,
        courseId: classTypeId,
        groupId: xkhTeacherCourseId
      })

      const that = this
      this.$confirm({
        // title: '',
        // content: h => <div>
        //           <div><span class="circle">&bull;</span>一讲只可解锁一次课前学。</div>
        //           <div><span class="circle">&bull;</span>解锁后不可再更改备课配置。</div>
        //         </div>,
        content: '确认解锁课前学吗？',
        centered: true,
        onOk() {
          return new Promise((resolve, reject) => {
            service.unlockBeforeLesson({ id: record.id, unlockType: 1 }).then(res => {
              resolve()
              that.getLessonList()
            }).catch(err => {
              reject(err)
            })
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'course-group-page-test'
      })
    },
    handleUnlockLesson(record) {
      const { id, xkhTeacherCourseId, classTypeId, lessonId, lockStatus } = record
      const param = { id, xkhTeacherCourseId, classTypeId, lessonId }
      if (this.selectedGroupItem && this.selectedGroupItem.sourceType) {
        param.sourceType = this.selectedGroupItem.sourceType
      }
      if (lockStatus === 1) {
        this.confirm(param)
        const { xkhTeacherCourseId, classTypeId, lessonId, aiLessonId } = record
        correctLogger.openLesson({
          lessonId,
          aiLessonId,
          courseId: classTypeId,
          groupId: xkhTeacherCourseId
        })
      }
    },
    confirm(param) {
      const thiz = this
      this.$confirm({
        title: '您确定解锁讲次吗？',
        content: h => <div>
            <div><span class="circle">&bull;</span>确定后，学生即可进入学AI课环节。</div>
          </div>,
        // <div><span class="circle">&bull;</span>确定后不可再更改备课配置。</div>
        onOk() {
          return new Promise((resolve, reject) => {
            service.unlockLesson(param).then(res => {
              resolve()
              thiz.getLessonList()
            }).catch(err => {
              reject(err)
            })
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'course-group-page-test'
      })
    },
    giveLesson(record) {
      const { id, xkhTeacherCourseId, classTypeId, lessonId, lockStatus } = record
      const param = { id, xkhTeacherCourseId, classTypeId, lessonId }
      if (lockStatus === 1) {
        this.$confirm({
          title: '您确定开始授课吗？',
          content: h =>
            (record.coursewareVersion
              ? <div>
                  <div><span class="circle">&bull;</span>确定后，学生即可进入学AI课环节</div>
                </div>
              : <div>
                  <div style="display:flex"><span class="circle">&bull;</span>检测到您未备课。确定后，系统将自动将所有视频片段推送至学习机</div>
                </div>),
          onOk: () => new Promise((resolve, reject) => {
            service.unlockLesson(param).then(res => {
              resolve()
              this.getLessonList()
              this.turnToGiveInstruction(record)
            }).catch(err => {
              reject(err)
            })
          }),
          onCancel() {
            console.log('Cancel')
          },
          class: 'course-group-page-test'
        })
        return
      }
      this.turnToGiveInstruction(record)
    },
    turnToGiveInstruction(record) {
      const { xkhTeacherCourseId, classTypeId, lessonId, aiLessonId, id, lessonName, lessonNum, coursewareVersion, lessonTag } = record
      window.open(`${this.$router.history.base}/inClass/giveInstruction?id=${id}&xkhTeacherCourseId=${xkhTeacherCourseId}&classTypeId=${classTypeId}&lessonId=${lessonId}&aiLessonId=${aiLessonId}&lessonName=${lessonName}&lessonNum=${lessonNum}&coursewareVersion=${coursewareVersion}&lessonTag=${lessonTag}`, '_blank')
    },
    correct(record, selectedGroupItem) {
      const { lessonTag } = record
      correctLogger.correctBtnLogger({
        groupId: selectedGroupItem.id,
        courseId: selectedGroupItem.classTypeId,
        lessonId: record.lessonId
      })
      if (selectedGroupItem.sourceType === 2) {
        const { href } = this.$router.resolve({
          name: 'inJzxCommonPage',
          query: {
            pageType: 4,
            planId: record.lessonId,
            source: record.source
          }
        })
        window.open(href, '_blank')
        return
      }
      if (!lessonTag) {
        const { groupName } = selectedGroupItem
        this.$router.push({
          name: 'checkDetailsPage',
          query: {
            groupId: selectedGroupItem.id,
            ...record,
            groupName
          }
        })
      } else {
        console.log('没操作')
      }
    }
  },
  setup(props, { root, parent, refs }) {
    const courseMaterialsVisible = ref(false)
    // 筛选项数据
    const searchParams = reactive({
      groupName: undefined,
      year: undefined,
      period: undefined,
      classCycles: undefined,
      timeIntervals: undefined
    })
    // 选中的小组
    const selectedGroupItem = ref(null)
    // 弹窗状态
    const modalVisible = ref(false)
    // 已选的讲次
    const selectedLesson = ref(null)
    // 看视频
    const videoVisible = ref(false)
    // 选中的小组
    const selectedLessonItem = ref(null)
    // 备课弹框状态
    const prePareLessonVisible = ref(false)
    // 是否白名单
    const teacherControl = computed(() => store.state.userInfo.userInfo.teacherControl)

    // 学年学期
    const yearListData = computed(() => {
      const list = []
      const { baseData } = store.state.common;
      (baseData.year || []).forEach(item => {
        (baseData.semester || []).forEach(innerItem => {
          list.push({
            id: `${item} ${innerItem}`,
            name: `${item} ${innerItem}`
          })
        })
      })
      return list
    })
    const diffColumns = ['studyUserCount', 'completeUserCount', 'correctionNum', 'repulseNum', 'excellentNum', 'correctionRate', 'studentSubmitRate']
    const columnsList = computed(() => {
      if (selectedGroupItem.value && selectedGroupItem.value.sourceType && selectedGroupItem.value.sourceType === 2) {
        return columns.filter(item => !diffColumns.includes(item.dataIndex))
      }
      return columns
    })
    /**
     * @description 获取需要滚动的高度
     */
    const getScroll = () => {
      const height = refs.table && refs.table.$el.offsetHeight
      const theadHeight = refs.table.$el.getElementsByTagName('thead')[0].offsetHeight
      scroll.value = { y: height - theadHeight - 16 }
    }

    /**
     * @description 颜色
     */
    const getColor = record => {
      const { lockStatus, correctionDivisionNum } = record
      // 已解锁
      if (lockStatus === 2) {
        if (correctionDivisionNum < 1) {
          return '#5db748'
        }
      }
    }

    // 左侧小组数据
    const {
      getGroupList,
      groupList,
      groupListLoading,
      groupPagination
    } = useGetGroupList(searchParams, selectedGroupItem)

    // 右侧课程数据
    const {
      lessonList,
      lessonTableLoading,
      getLessonList,
      scroll
    } = useGetLessonList(selectedGroupItem, refs)

    // keep-alive 刷新课程信息
    onActivated(() => {
      correctLogger.initPageLogger()
      // const { params } = root._route
      // // 从批改页进来不用刷新小组列表
      // if (params && !params.noRefreshGroup) {
      //   getGroupList()
      // }
      getGroupList()
      getLessonList()
    })

    /**
     * @description 点击重置
     */
    const handleResetBtnClick = () => {
      Object.keys(searchParams).forEach(item => {
        searchParams[item] = undefined
      })
    }

    /**
     * @description 点击搜索
     */
    const handleSearchBtnClick = () => {
      selectedGroupItem.value = null
      getGroupList()
    }

    /**
     * @description 处理小组编辑事件
     */
    const handleGroupItemClick = item => {
      selectedGroupItem.value = item
      modalVisible.value = true
    }

    /**
     * @description 查看课程
     */
    const handleScanVideo = item => {
      correctLogger.selCourseLogger({
        groupId: selectedGroupItem.id,
        courseId: selectedGroupItem.classTypeId
      })
      const { lessonName, aiLessonId, lessonId, classTypeId } = item
      root.$router.push({
        name: 'scanVideo',
        query: {
          groupId: selectedGroupItem.id,
          lessonName,
          aiLessonId,
          lessonId,
          classTypeId
        }
      })
      // selectedLesson.value = item
      // videoVisible.value = true
    }

    /**
     * @description 解锁讲次
     */
    const operateTxt = record => {
      const { lessonTag, lockStatus } = record
      if (lockStatus === 1) {
        return '解锁讲次'
      }
      // 0普通讲次 1期中讲次 2期末讲次
      if (lessonTag) {
        return '已解锁'
      }
      return '批改'
    }

    /**
     * @description 是否展示空
     */
    const isEmptyCpm = (text, record) => {
      const { lockStatus, lessonTag } = record
      // 未解锁
      if (lockStatus === 1 && !text) return true
      // 期中 期末
      if (lessonTag === 1 || lessonTag === 2) return true
      return false
    }
    /**
     * 右侧刷新讲次列表
     */
    const refreshLesson = async () => {
      getLessonList(true, groupList)
    }

    /**
     * 讲次列表每行的 class
     */
    const lessonRowClass = (record, index) => {
      // lockStatus 1：未解锁  2：解锁
      const { lockStatus } = record
      if (lockStatus === 1) {
        return 'lesson-row-unlock'
      }
      return ''
    }

    /**
     * 备课弹窗
     */
    const updatePrePareLesson = (updateStatus, record) => {
      if (updateStatus) {
        selectedLessonItem.value = record
        prePareLessonVisible.value = true
      } else {
        prePareLessonVisible.value = false
        getLessonList()
      }
    }

    const getCourseDetail = () => {
      courseMaterialsVisible.value = true
    }

    watch(
      () => root._route.query,
      val => {
        // 路由变化关闭弹窗
        prePareLessonVisible.value = false
      }
    )

    return {
      getCourseDetail,
      scroll,
      modalVisible,
      courseMaterialsVisible,
      selectedGroupItem,
      columnsList,
      groupListLoading,
      groupList,
      groupPagination,
      searchParams,
      handleSearchBtnClick,
      handleResetBtnClick,
      handleGroupItemClick,
      lessonTableLoading,
      lessonList,
      getLessonList,
      selectedLesson,
      handleScanVideo,
      videoVisible,
      yearListData,
      operateTxt,
      isEmptyCpm,
      getColor,
      getScroll,
      refreshLesson,
      lessonRowClass,
      prePareLessonVisible,
      selectedLessonItem,
      teacherControl,
      updatePrePareLesson
    }
  }
})
</script>
<style lang="less">
.confirm-item {
  width: 80px;
  height: 80px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  line-height: 80px;
  text-align: center;
  margin: 10px;
}

.course-group-page-test {
  .ant-modal-confirm-body {
    // align-items: start !important;
    padding: 0 15px;
    .ant-modal-confirm-title {
      margin-bottom: 20px !important;
    }
    .ant-modal-confirm-content {
      margin-top: 0 !important;
    }
  }
  .circle {
    display: inline-block;
    min-width: 22px;
    text-align: center;
    font-weight: 800;
  }
}
.modal-course-title-wrap {
  display: flex;
  .course-name-wrap {
    display: flex;
    align-items: center;
  }
  .course-name {
    display: inline-block;
    max-width: 230px;
    font-family: 'Microsoft YaHei UI';
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.04em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #70788C;
  }
  .course-id {
    font-family: 'Microsoft YaHei UI';
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.04em;
    color: #70788C;
  }
}

</style>
<style lang="less" scoped>
:deep(.selected-row) {
  color: #3262FD;
}
:deep(.ant-modal-confirm) {
  .ant-modal-confirm-title {
    text-align: left;
  }
}
.course-group-page {
  height: 100%;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  .filter {
    .select-item {
      width: 100%;
    }
  }
  .result {
    flex: 1;
    margin-top: 24px;
    overflow: hidden;
    .course-list {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-left: 12px;
      overflow: hidden;
      .header {
        flex: 0 0 30px;
        margin-bottom: 20px;
        .label {
          font-size: 20px;
          font-weight: bold;
          vertical-align: sub;
        }
      }
      .table {
        flex: 1;
        overflow: hidden;
        :deep(.tag) {
          color: #fff;
          background: #FF5C5C;
          font-size: 12px;
          padding: 2px;
          border-radius: 4px;
          word-break: keep-all;
        }
      }
      .pagination {
        text-align: right;
        padding-top: 12px;
      }
    }
    .group-list {
      height: 100%;
      padding: 0 12px 0 0;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #ddd;
      .label {
        font-size: 20px;
        font-weight: bold;
        margin-right: 20px;
        vertical-align: sub;
      }
      .list-wrap {
        display: flex;
        position: relative;
        flex-direction: column;
        height: 100%;
        .spin {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 100;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0,0,0,0.02);
        }
        .list {
          flex: 1;
          overflow-y: scroll;
          .empty {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .pagination {
          text-align: right;
        }
      }
    }
  }
  .operate {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
:deep(.lesson-row-unlock) {
  td {
    color: #98A2B2
  }
}
.min-width {
  min-width: 100px;
  word-break: keep-all;
}
.min-width-slot-title {
  min-width: 60px;
  word-break: keep-all;
}
</style>
